export const PAGE_OPTIONS = [
  {
    code: "homepage",
    url: "/",
  },
  {
    code: "surveys",
    url: "/encuestas",
  },
  /* {
    code: "data",
    url: "/conversacion",
  }, */
  {
    code: "prensa",
    url: "/mixed-feelings",
  },
  {
    code: "toolkit",
    url: "/toolkit",
  },
  {
    code: "knowledge",
    url: "/experimentos",
  },
  {
    code: "resources",
    url: "/recursos",
  },
  {
    code: "about",
    url: "/sobre",
  },
];
